import { render, staticRenderFns } from "./BillingPaymentsCard.vue?vue&type=template&id=68e32000&scoped=true&"
import script from "./BillingPaymentsCard.vue?vue&type=script&lang=js&"
export * from "./BillingPaymentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e32000",
  null
  
)

export default component.exports